import React from 'react';
import Select from 'react-select';

const ERROR_COLOR = '#d32f2f';
const FOCUS_COLOR = '#1A3853';

const baseStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.selectProps?.error
      ? ERROR_COLOR
      : state.isFocused
        ? FOCUS_COLOR
        : '#ced4da',
    boxShadow: state.selectProps?.error
      ? state.isFocused
        ? `0 0 0 1px ${ERROR_COLOR}`
        : 'none'
      : state.isFocused
        ? `0 0 0 1px ${FOCUS_COLOR}`
        : 'none',
    '&:hover': {
      borderColor: state.selectProps?.error ? ERROR_COLOR : FOCUS_COLOR,
    },
    minHeight: '40px',
    fontSize: '14px',
    borderRadius: '5px',
    lineHeight: '1.8',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? FOCUS_COLOR : state.isFocused ? '#f1f1f1' : 'white',
    color: state.isSelected ? 'white' : '#333',
    fontSize: '14px',
    padding: '8px 12px',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '40px',
  }),
};

const mergeStyles = (overrideStyles = {}) => {
  const merged = { ...baseStyles };

  Object.keys(overrideStyles).forEach((key) => {
    const baseFn = baseStyles[key];
    const overrideFn = overrideStyles[key];

    if (typeof baseFn === 'function' && typeof overrideFn === 'function') {
      merged[key] = (base, state) => overrideFn(baseFn(base, state), state);
    } else {
      merged[key] = overrideFn;
    }
  });

  return merged;
};

const CustomSelect = ({ styles: overrideStyles, error = false, ...props }) => (
  <Select
    {...props}
    error={error}
    styles={mergeStyles(overrideStyles)}
    menuPortalTarget={document.body}
  />
);

export default CustomSelect;
